import { render, staticRenderFns } from "./MaterialDetailModify.vue?vue&type=template&id=ccbcaa84&scoped=true&"
import script from "./MaterialDetailModify.vue?vue&type=script&lang=js&"
export * from "./MaterialDetailModify.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDetailModify.vue?vue&type=style&index=0&id=ccbcaa84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbcaa84",
  null
  
)

export default component.exports